var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 448,
    height: 512,
    viewBox: "0 0 448 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M201.4 374.6C213.9 387.1 234.2 387.1 246.7 374.6L406.7 214.6C419.2 202.1 419.2 181.8 406.7 169.3C394.2 156.8 373.9 156.8 361.4 169.3L224 306.7L86.5998 169.4C74.0998 156.9 53.7998 156.9 41.2998 169.4C28.7998 181.9 28.7998 202.2 41.2998 214.7L201.3 374.7L201.4 374.6Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleArrow);
export default __webpack_public_path__ + "static/media/toggle-arrow.7d95031d433ff2a8635282362a8ae95a.svg";
export { ForwardRef as ReactComponent };